import React from 'react';
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  CircularProgress,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useClientByUserId } from '../../hooks/useClient';
import ClientProfileForm from '../../components/client/ClientProfileForm';

const ClientEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const userId = parseInt(id || '0');
  
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const { data: client, isLoading, error } = useClientByUserId(userId);
  
  const handleNavigateToDetails = () => {
    navigate(`/clients/${userId}`);
  };
  
  const handleNavigateToList = () => {
    navigate('/clients');
  };
  
  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="400px">
        <CircularProgress />
      </Box>
    );
  }
  
  if (error || !client) {
    return (
      <Box p={3}>
        <Typography color="error">
          {t('client.errorLoadingClient')}: {error?.message || t('client.notFound')}
        </Typography>
      </Box>
    );
  }
  
  return (
    <Box p={3}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h2">{t('client.editClient')}</Typography>
      </Box>
      
      <Breadcrumbs separator="›" aria-label="breadcrumb" sx={{ mb: 3 }}>
        <Link
          underline="hover"
          color="inherit"
          onClick={handleNavigateToList}
          sx={{ cursor: 'pointer' }}
        >
          {t('client.clientList')}
        </Link>
        <Link
          underline="hover"
          color="inherit"
          onClick={handleNavigateToDetails}
          sx={{ cursor: 'pointer' }}
        >
          {client.user?.firstName} {client.user?.lastName}
        </Link>
        <Typography color="text.primary">{t('common.edit')}</Typography>
      </Breadcrumbs>
      
      <ClientProfileForm isOnboarding={false} clientToEdit={client} />
    </Box>
  );
};

export default ClientEdit;